import styled from '@emotion/styled';
import { Color } from '@diritto/common/style/color';

const colorArray = [
  Color.Primary500,
  Color.Blue500,
  Color.Red500,
  Color.Orange500,
  Color.Green500,
  Color.Yellow500,
  Color.White,
  Color.Black,
];

interface ColorPickerProps {
  textColor: string;
  onChange: (color: string) => void;
}

export const ColorPicker = ({ onChange, textColor }: ColorPickerProps) => {
  const onChangeInput = (text: string) => {
    const hexRegex = /^#[a-fA-F0-9]{0,6}/;
    if (hexRegex.test(text)) {
      onChange(text);
    }
  };
  const onColorClick = (color: string) => {
    onChange(color);
  };

  return (
    <StyledContainer>
      {colorArray.map(color => (
        <StyledColorOption key={color} color={color} onClick={() => onColorClick(color)} />
      ))}
      <StyledHex>#</StyledHex>
      <StyledHexInput
        maxLength={6}
        value={textColor.replace('#', '')}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeInput(`#${e.target.value}`)}
      />
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  width: 240px;
  background: rgb(255, 255, 255);
  border: 0 solid rgba(0, 0, 0, 0.25);
  box-shadow: rgb(0 0 0 / 25%) 0 1px 4px;
  border-radius: 4px;
  padding: 15px 9px 9px 15px;
  position: absolute;
  bottom: 0;
  right: 30px;
`;

const StyledColorOption = styled.div`
  background-color: ${props => props.color};
  height: 30px;
  width: 30px;
  cursor: pointer;
  position: relative;
  outline: none;
  float: left;
  border-radius: 4px;
  margin: 0 6px 6px 0;
  border: 1px solid rgb(234, 238, 242);
`;

const StyledHex = styled.div`
  background: rgb(240, 240, 240);
  height: 30px;
  width: 30px;
  border-radius: 4px 0 0 4px;
  float: left;
  color: rgb(152, 161, 164);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledHexInput = styled.input`
  font-size: 14px;
  color: #666666;
  border: 0;
  outline: none;
  height: 28px;
  width: 98px;
  box-shadow: #f0f0f0 0 0 0 1px inset;
  box-sizing: content-box;
  border-radius: 0 4px 4px 0;
  float: left;
  padding-left: 8px;
`;
